import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Col, Row, FormLabel, Button, FormGroup,
    Image as BootstrapImage,
} from 'react-bootstrap';
import { toast } from 'react-toastify';

import { StdModalDialog } from './dialog';
import { CheckboxField, InputField } from './edit_blocks';
import { API_DOMAIN } from '../const';
import { getBase64 } from '../tools/files';

export default class GalleryBlock extends React.Component {
    constructor(props) {
        super(props);
        this.state = { picData: {}, loadPicUrlModalOpen: false };
        this.handlePicChange = this.handlePicChange.bind(this);
        this.handleGifChange = this.handleGifChange.bind(this);
        this.pictureHandleChange = this.pictureHandleChange.bind(this);
        this.onPictureChange = this.onPictureChange.bind(this);
        this.onPicUrlChange = this.onPicUrlChange.bind(this);
        this.onLoadPicByUrl = this.onLoadPicByUrl.bind(this);
        this.toggleLoadPicModal = this.toggleLoadPicModal.bind(this);
        this.removePic = this.removePic.bind(this);
        this.editPic = this.editPic.bind(this);
        this.imageReceived = this.imageReceived.bind(this);
        this.closeModal = this.closeModal.bind(this);

        if (!this.props.gallery) {
            this.state.gallery = {};
        } else {
            this.state.gallery = this.props.gallery;
        }

        this.GALLERY_PICS_URI = `gallery/${this.state.gallery.id}/pics/`;
        this.GALLERY_VIDEOS_URI = `gallery/${this.state.gallery.id}/videos/`;
    }

    getPictures() {
        fetch(`${API_DOMAIN + this.GALLERY_PICS_URI}?limit=9999`)
            .then((response) => response.json())
            .then((data) => this.setState({ loading: false, ...data }));
    }

    getGifs() {
        fetch(`${API_DOMAIN + this.GALLERY_VIDEOS_URI}?limit=9999`)
            .then((response) => response.json())
            .then((data) => this.setState({ gifList: data.results }));
    }

    componentDidMount() {
        if (!this.state.gallery) {
            return null;
        }

        this.getPictures();
        this.getGifs();
    }

    componentDidUpdate(prevProps) {
        if (!this.props.gallery?.id || this.props.gallery.id === prevProps.gallery?.id) {
            return null;
        }

        this.GALLERY_PICS_URI = `gallery/${this.props.gallery.id}/pics/`;
        this.GALLERY_VIDEOS_URI = `gallery/${this.props.gallery.id}/videos/`;

        this.getPictures();
        this.getGifs();
    }

    editPic(event) {
        fetch(`${API_DOMAIN + this.GALLERY_PICS_URI + event.currentTarget.id}/`)
            .then((response) => response.json())
            .then((data) => this.setState({ picData: data }));
        this.setState({ modalIsOpen: true });
    }

    removePic(event) {
        fetch(`${API_DOMAIN + this.GALLERY_PICS_URI + event.currentTarget.id}/`, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                this.getPictures();
                toast.success('Успешно удалено!');
            })
            .catch((e) => toast.error(`Ошибка удаления ${e}`));
    }

    removeGif = (event) => {
        fetch(`${API_DOMAIN + this.GALLERY_VIDEOS_URI + event.currentTarget.id}/`, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                this.getGifs();
                toast.success('Успешно удалено!');
            })
            .catch((e) => toast.error(`Ошибка удаления ${e}`));
    };

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    fillGallery() {
        if (!this.state.results) {
            return null;
        }

        const pictures_all = [];
        let pictures_row = [];
        let cell_count = 0;

        for (let r = 0; r < this.state.results.length; r++) {
            cell_count += 1;
            pictures_row.push(
                <Col key={`pic_${this.state.results[r].id}`} md={4}>
                    <Row key={`pic_buttons_${this.state.results[r].id}`}>
                        <Col md={1}>
                            <Button
                                variant="link"
                                id={this.state.results[r].id}
                                onClick={this.editPic}
                            >
                                <FontAwesomeIcon
                                    id={this.state.results[r].id}
                                    icon="pencil-alt"
                                />
                            </Button>
                        </Col>
                        <Col md={{ offset: 6, span: 1 }}>
                            <Button
                                variant="link"
                                id={this.state.results[r].id}
                                onClick={this.removePic}
                            >
                                <FontAwesomeIcon
                                    icon="trash"
                                    id={this.state.results[r].id}
                                />
                            </Button>
                        </Col>
                    </Row>
                    <Row key={`pic_${this.state.results[r].id}`}>
                        <Col md={12}>
                            <Button
                                id={this.state.results[r].id}
                                data-filename={this.state.results[r].filename}
                                variant="link"
                                onClick={this.props.imgClickHandler}
                            >
                                <BootstrapImage
                                    id={this.state.results[r].id}
                                    src={this.state.results[r].url}
                                    fluid
                                    rounded
                                />
                            </Button>

                            <a href={this.state.results[r].url} target="_blank" rel="noopener noreferrer">
                                <p style={{ wordBreak: 'break-all' }} id={this.state.results[r].id}>
                                    {this.state.results[r].filename}
                                </p>
                            </a>
                        </Col>
                    </Row>
                </Col>,
            );

            if (cell_count === 3) {
                cell_count = 0;
                pictures_all.push(<Row key={`pic_rowbundle_${this.state.results[r].id}`}>{pictures_row}</Row>);
                pictures_row = [];
            }
        }

        pictures_all.push(<Row key="pic_rowfull">{pictures_row}</Row>);

        return (<Col md={12}>{pictures_all}</Col>);
    }

    fillGifGallery = () => {
        if (!this.state.gifList) {
            return null;
        }

        return this.state.gifList.map((gif) => (
            <Col key={`gif_${gif.id}`} md={4}>
                <Row>
                    <Col md={{ offset: 6, span: 1 }}>
                        <Button
                            variant="link"
                            id={gif.id}
                            onClick={this.removeGif}
                        >
                            <FontAwesomeIcon
                                icon="trash"
                                id={gif.id}
                            />
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Button
                            id={gif.id}
                            data-filename={gif.filename}
                            variant="link"
                            onClick={this.props.imgClickHandler}
                        >
                            <video src={gif.url} style={{ width: '100%' }} />
                        </Button>

                        <a href={gif.url} target="_blank" rel="noopener noreferrer">
                            <p style={{ wordBreak: 'break-all' }} id={gif.id}>
                                {gif.filename}
                            </p>
                        </a>
                    </Col>
                </Row>
            </Col>
        ));
    };

    createGallery() {
        return new Promise((resolve) => {
            fetch(`${API_DOMAIN}gallery/`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    entity_alias: this.props.entity_alias,
                    entity_id: this.props.entity_id,
                }),
            })
                .then((response) => response.json())
                .then((data) => {
                    this.GALLERY_PICS_URI = `gallery/${data.id}/pics/`;
                    this.setState({ gallery: data });
                    this.props.handleGalleryChange(this.state.gallery);
                    resolve(data);
                });
        });
    }

    sendPic(data, filename, filtetype, gallery_uri) {
        fetch(API_DOMAIN + gallery_uri, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                file: data, name: filename, length: data.length, type: filtetype,
            }),
        })
            .then((response) => Promise.all([response, response.json()]))
            .then(([response, json]) => {
                if (!response.ok) {
                    throw Error(json.detail);
                }

                toast.success('Успешно сохранено!');
                this.getPictures();
            })
            .catch((e) => toast.error(String(e)));
    }

    getGif(data, filename, filetype, gallery_uri) {
        fetch(API_DOMAIN + gallery_uri, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                file: data, name: filename, length: data.length, type: filetype,
            }),
        })
            .then((response) => Promise.all([response, response.json()]))
            .then(([response, json]) => {
                if (!response.ok) {
                    throw Error(json.detail);
                }

                toast.success('Успешно сохранено!');
                this.getGifs();
            })
            .catch((e) => toast.error(String(e)));
    }

    pictureHandleChange(event) {
        let state = event.currentTarget.value;

        if (event.currentTarget.type === 'author_email') {
            state = event.currentTarget.value.value;
        }

        if (event.currentTarget.type === 'checkbox') {
            state = event.currentTarget.checked;
        }

        delete this.state.picData.url;
        const new_state = this.state.picData;
        new_state[event.currentTarget.id] = state;
        this.setState({ picData: new_state });
    }

    handlePicChange(event) {
        const { files } = event.currentTarget;

        if (!this.props.gallery?.id) {
            this.createGallery()
                .then(() => this.uploadPics(files));
        } else {
            this.uploadPics(files);
        }
    }

    handleGifChange(event) {
        const { files } = event.currentTarget;

        if (!this.props.gallery?.id) {
            this.createGallery()
                .then(() => this.uploadGifs(files));
        } else {
            this.uploadGifs(files);
        }
    }

    uploadGifs(files) {
        for (let i = 0; i < Object.keys(files).length; i++) {
            const file = files[i];
            getBase64(file, (result) => {
                this.getGif(result, file.name, file.type, this.GALLERY_VIDEOS_URI);
                this.fillGallery();
            });
        }
    }

    uploadPics(files) {
        for (let i = 0; i < Object.keys(files).length; i++) {
            const file = files[i];
            getBase64(file, (result) => {
                this.sendPic(result, file.name, file.type, this.GALLERY_PICS_URI);
                this.fillGallery();
            });
        }
    }

    modalBody() {
        return (
            <div>
                <Row>
                    <Col md={12}>
                        <InputField
                            name="descr"
                            label="Подпись"
                            value={this.state.picData.descr}
                            onChange={this.pictureHandleChange}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <InputField
                            name="link"
                            label="Переход по клику на URL"
                            value={this.state.picData.link}
                            onChange={this.pictureHandleChange}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <CheckboxField
                            name="is_main"
                            label="Главная"
                            value={this.state.picData.is_main}
                            onChange={this.pictureHandleChange}
                        />
                    </Col>
                    <Col md={6}>
                        <CheckboxField
                            name="is_published"
                            label="Опубликована"
                            value={this.state.picData.is_published}
                            onChange={this.pictureHandleChange}
                        />
                    </Col>
                </Row>
            </div>
        );
    }

    onPictureChange() {
        const uri = `${API_DOMAIN + this.GALLERY_PICS_URI + this.state.picData.id}/`;

        fetch(uri, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(this.state.picData),
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                response.json();
            })
            .then((data) => this.setState({ picResult: data }))
            .then(() => {
                toast.success('Успешно сохранено!');
            })
            .then(this.closeModal)
            .catch((e) => toast.error(`Ошибка сохранения ${e}`));
    }

    onPicUrlChange(event) {
        this.setState({ picUrl: event.currentTarget.value });
    }

    imageReceived(event) {
        const canvas = document.createElement('canvas');
        const img = event.target;
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const img_path_split = img.src.split('/');
        const img_name = img_path_split[img_path_split.length - 1];
        const img_type = `image/${img_name.split('.')[1]}`;
        const data = canvas.toDataURL().replace('image/png;', `${img_type};`);

        this.sendPic(data, img_name, img_type, this.GALLERY_PICS_URI);
        this.toggleLoadPicModal();
    }

    onLoadPicByUrl() {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.src = this.state.picUrl;
        img.addEventListener('load', this.imageReceived, false);
    }

    toggleLoadPicModal() {
        this.setState({ loadPicUrlModalOpen: !this.state.loadPicUrlModalOpen });
    }

    render() {
        return (
            <div>
                <FormLabel><b>Галереи</b></FormLabel>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={6}>
                                Картинки
                                {' '}
                                <span
                                    style={{
                                        color: '#999', fontSize: '13px', marginBottom: '8px', display: 'inline-block',
                                    }}
                                >
                                    (.jpg, .png, .webp)
                                </span>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={12}>
                        <Row>
                            <Col md={6}>
                                <FormGroup controlId="save">
                                    <input
                                        accept="image/jpeg,image/png,image/webp"
                                        multiple="multiple"
                                        id="gallery_pic"
                                        type="file"
                                        onChange={this.handlePicChange}
                                        ref={(ref) => this.loadPicToGalleryInput = ref}
                                        style={{ display: 'none' }}
                                    />
                                    <Button
                                        variant="outline-dark"
                                        block
                                        onClick={() => this.loadPicToGalleryInput.click()}
                                    >
                                        <FontAwesomeIcon
                                            icon="hdd"
                                        />
                                        {' '}
                                        С диска
                                    </Button>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup controlId="save">
                                    <Button
                                        variant="outline-dark"
                                        block
                                        onClick={this.toggleLoadPicModal}
                                    >
                                        <FontAwesomeIcon
                                            icon="link"
                                        />
                                        {' '}
                                        По URL
                                    </Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    {this.fillGallery()}
                </Row>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={6}>
                                Гифки
                                {' '}
                                <span
                                    style={{
                                        color: '#999', fontSize: '13px', marginBottom: '8px', display: 'inline-block',
                                    }}
                                >
                                    (.mp4)
                                </span>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={12}>
                        <Row>
                            <Col md={6}>
                                <FormGroup controlId="save">
                                    <input
                                        accept="video/mp4"
                                        multiple="multiple"
                                        id="gallery_gif"
                                        type="file"
                                        onChange={this.handleGifChange}
                                        ref={(ref) => this.loadGifToGalleryInput = ref}
                                        style={{ display: 'none' }}
                                    />
                                    <Button
                                        variant="outline-dark"
                                        block
                                        onClick={() => this.loadGifToGalleryInput.click()}
                                    >
                                        <FontAwesomeIcon
                                            icon="hdd"
                                        />
                                        {' '}
                                        С диска
                                    </Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    {this.fillGifGallery()}
                </Row>
                <StdModalDialog
                    isOpen={this.state.modalIsOpen}
                    container={this}
                    hideHandler={this.closeModal}
                    closeHandler={this.closeModal}
                    title={this.state.picData.filename}
                    body={this.modalBody()}
                    onSave={this.onPictureChange}
                />
                <StdModalDialog
                    isOpen={this.state.loadPicUrlModalOpen}
                    container={this}
                    hideHandler={this.toggleLoadPicModal}
                    closeHandler={this.toggleLoadPicModal}
                    title="Укажите URL"
                    body={(
                        <Row>
                            <Col md={12}>
                                <InputField
                                    name="link"
                                    label=""
                                    value={this.state.picUrl}
                                    onChange={this.onPicUrlChange}
                                />
                            </Col>
                        </Row>
                    )}
                    onSave={this.onLoadPicByUrl}
                />

            </div>
        );
    }
}
